import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Heart, Globe, Users, Gift } from 'lucide-react';
export function Philanthropy() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.5
  }} className="min-h-screen bg-white" data-id="element-462">
      <Header data-id="element-463" />

      <main className="pt-32 pb-24" data-id="element-464">
        <section className="max-w-7xl mx-auto px-6 mb-32 text-center" data-id="element-465">
          <span className="section-overline" data-id="element-466">Partnerships</span>
          <h1 className="text-[#4A0E0E] mb-8" data-id="element-467">Nonprofit Initiatives</h1>
          <p className="text-[#2C2C2C]/60 max-w-3xl mx-auto text-lg" data-id="element-468">
            Cork Dorx is committed to supporting fundraising and nonprofit
            initiatives through strategic partnerships that leverage wine
            culture for social good.
          </p>
        </section>

        <section className="max-w-7xl mx-auto px-6 mb-32" data-id="element-469">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-470">
            <div className="order-2 md:order-1" data-id="element-471">
              <h2 className="text-4xl font-serif text-[#4A0E0E] mb-8" data-id="element-472">
                Wine for a Cause
              </h2>
              <p className="text-[#2C2C2C]/70 mb-8 leading-relaxed" data-id="element-473">
                We believe in the power of community and the importance of
                giving back. Our philanthropic partnerships range from charity
                auctions to benefit galas, where we provide both our expertise
                and our resources to help organizations reach their goals.
              </p>
              <div className="space-y-4" data-id="element-474">
                <div className="flex items-center gap-4 text-[#4A0E0E] font-bold uppercase tracking-widest text-xs" data-id="element-475">
                  <div className="w-8 h-[1px] bg-[#D4AF37]" data-id="element-476" /> Charity Auctions
                </div>
                <div className="flex items-center gap-4 text-[#4A0E0E] font-bold uppercase tracking-widest text-xs" data-id="element-477">
                  <div className="w-8 h-[1px] bg-[#D4AF37]" data-id="element-478" /> Benefit Galas
                </div>
                <div className="flex items-center gap-4 text-[#4A0E0E] font-bold uppercase tracking-widest text-xs" data-id="element-479">
                  <div className="w-8 h-[1px] bg-[#D4AF37]" data-id="element-480" /> Community
                  Outreach
                </div>
              </div>
            </div>
            <div className="order-1 md:order-2 rounded-3xl overflow-hidden h-[600px]" data-id="element-481">
              <img src="https://cdn.magicpatterns.com/uploads/hcxh9fRA9aKPJoFRf1fgQs/IMG_4005.jpg" alt="Philanthropy" className="w-full h-full object-cover" data-id="element-482" />
            </div>
          </div>
        </section>

        <section className="bg-[#FDFCF0] py-32 px-6" data-id="element-483">
          <div className="max-w-7xl mx-auto text-center" data-id="element-484">
            <h2 className="text-3xl font-serif text-[#4A0E0E] mb-16" data-id="element-485">
              Our Impact
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-12" data-id="element-486">
              {[{
              label: 'Partner Orgs',
              value: '50+'
            }, {
              label: 'Funds Raised',
              value: '$2M+'
            }, {
              label: 'Events Hosted',
              value: '200+'
            }, {
              label: 'Lives Impacted',
              value: '10k+'
            }].map((stat, idx) => <div key={idx} data-id="element-487">
                  <div className="text-5xl font-serif text-[#D4AF37] mb-2" data-id="element-488">
                    {stat.value}
                  </div>
                  <div className="text-[#4A0E0E] font-bold uppercase tracking-widest text-[10px]" data-id="element-489">
                    {stat.label}
                  </div>
                </div>)}
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-490" />
    </motion.div>;
}